<template>
  <v-expansion-panel>
    <div class="section-box section-box-list" v-for="(plan, i) in plans" :key="i">
      <v-expansion-panel-content expand-icon="fal fa-angle-down">
        <div slot="header">
          {{ plan.description }} -
          {{ plan.auto_recurring.transaction_amount | formatCurrency }}
        </div>
        <section class="mx-4">
          <v-layout row wrap align-center>
            <v-flex xs12 md3>
              <v-text-field label="Título" v-model="plan.description"
                hide-details required></v-text-field>
            </v-flex>
            <v-flex xs12 md3>
              <v-text-field label="Valor" v-model="plan.auto_recurring.transaction_amount"
                hide-details required></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              Frequência:
              <strong>{{ plan.auto_recurring.frequency }} {{ plan.auto_recurring.frequency_type }}</strong>
            </v-flex>
          </v-layout>

          <v-card-actions>
            <v-btn @click.stop="savePlan(plan)" round large depressed color="success"
              :loading="loadingRequest">
              Salvar alteração
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </section>
      </v-expansion-panel-content>
    </div>
  </v-expansion-panel>
</template>

<script>
import axios from 'axios'
import EventBus from '@/event-bus'

export default {
  data: () => ({
    plans: [],
    createPlan: {
      test: {
        'description': 'Teste 1 Real',
        'auto_recurring': {
          'frequency': 1,
          'frequency_type': 'days',
          'transaction_amount': 1,
          'currency_id': 'BRL'
        }
      },
      trimestral: {
        'description': 'Plano Trimestral',
        'auto_recurring': {
          'frequency': 3,
          'frequency_type': 'months',
          'transaction_amount': 705,
          'currency_id': 'BRL'
        }
      },
      semestral: {
        'description': 'Plano Semestral',
        'auto_recurring': {
          'frequency': 6,
          'frequency_type': 'months',
          'transaction_amount': 1209,
          'currency_id': 'BRL'
        }
      },
      mensal: {
        'description': 'Plano Mensal',
        'auto_recurring': {
          'frequency': 30,
          'frequency_type': 'days',
          'transaction_amount': 309,
          'currency_id': 'BRL'
        }
      }
    },
    loadingRequest: false
  }),

  methods: {
    loadPlans () {
      for (let plan of Object.keys(API.plans)) {
        const planID = API.plans[plan]
        const path = `${API.mpPlans}/${planID}`
        axios.get(path).then(response => {
          if (response && response.data && response.data.plan.response) {
            this.plans.push(response.data.plan.response)
          }
        })
      }
    },

    create (plan) {
      const path = `${API.mpPlans}`
      axios.post(path, plan)
    },

    savePlan (plan) {
      this.loadingRequest = true
      const path = `${API.mpPlans}/${plan.id}`

      const params = {
        description: plan.description,
        auto_recurring: {
          transaction_amount: parseInt(plan.auto_recurring.transaction_amount)
        }
      }

      axios.put(path, params).then(response => {
        this.loadingRequest = false
      }).catch(errors => {
        this.loadingRequest = false
        EventBus.$emit('showSnackbar', { message: errors.response.data.message, color: 'error' })
      })
    },

    deletePlan (plan) {
      this.loadingRequest = true
      const path = `${API.mpPlans}/${plan.id}`
      axios.delete(path)
    }
  },

  mounted () {
    this.loadPlans()
  }
}
</script>

<style scoped>
.v-expansion-panel {
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/financial/FinancialPlansList.vue